<template>
  <div class="rentBook">
    <ComponentsList ref="componentsList" :props-columns="columns" :props-data="propsData" :search-form="searchForm">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :rules="searchFormRules"
        :inline="true"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="设备SN号：" prop="deviceNo">
          <el-input
            v-model="searchForm.deviceNo"
            name="deviceNo"
            placeholder="请输入设备SN号"
            class="handle-form-input"
            maxlength="22"
            clearable
          />
        </el-form-item>
        <el-form-item label="超管账号：" prop="accountPhone">
          <el-input
            v-model="searchForm.accountPhone"
            name="accountPhone"
            placeholder="请输入超管账号"
            class="handle-form-input"
            maxlength="15"
            clearable
          />
        </el-form-item>
        <el-form-item label="创建时间：" prop="time">
          <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="截至时间"
            class="handle-form-input"
            @focus="dafaultVulue"
            @change="timeChange"
          />
        </el-form-item>
        <el-form-item label="图书编码：" prop="bookCode">
          <el-input
            v-model="searchForm.bookCode"
            name="bookCode"
            placeholder="请输入图书编码"
            class="handle-form-input"
            maxlength="50"
            clearable
          />
        </el-form-item>
        <el-form-item label="支付时间：" prop="paytime">
          <el-date-picker
            v-model="searchForm.paytime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="截至时间"
            class="handle-form-input"
            @change="paytimeChange"
            @focus="dafaultPayVulue"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
          <el-button
            size="medium"
            icon="el-icon-refresh-right"
            @click="handleSearchReset"
          >
            重置
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="exportExcel"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
    </ComponentsList>
  </div>
</template>

<script>
import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import ComponentsList from '@/views/financialCenter/ellaRentBooks/common/componentsList';
import { columnsRentBook } from '@/views/financialCenter/ellaRentBooks/common/columns';
import { getDateTime, deepCopy } from '@/utils/index';

export default {
  name: 'RentBook',
  components: { ComponentsList },
  data() {
    // SN号
    const validateDeviceSn = (rule, value, callback) => {
      if (!value) callback();
      const pattern = new RegExp(/^[\d\s-_*]+$|^[A-Za-z\s\d-_*]+$/);
      if (!pattern.test(value)) {
        callback(new Error('请输入数字或字母字符'));
      } else if (value.toString().length > 20) {
        callback(new Error('请输入20以内的字符'));
      } else {
        callback();
      }
    };
      // 请输入1-11位数字
    const validateAccountPhone = (rule, value, callback) => {
      if (!value) callback();
      const pattern = new RegExp(/(^\d*$)/);
      if (!pattern.test(value)) {
        callback(new Error('请输入1-11位数字'));
      } else if (value.toString().length > 11 || value.toString().length < 1) {
        callback(new Error('请输入1-11位数字'));
      } else {
        callback();
      }
    };
    // 创建时间 支付时间
    const validateDatePicker = (rule, value, callback) => {
      if (!(value && value.length > 0)) callback();
      else if (value && value.length > 1 && value[0] && value[1]) {
        const end = new Date(value[1]);
        const start = new Date(value[0]);
        if ((end.getTime() - start.getTime()) > (3 * 30 * 24 * 60 * 60 * 1000 - 8.64e7)) {
          callback(new Error('请选择90天内的数据'));
        } else {
          callback();
        }
      }
    };
    return {
      searchForm: {
        time: [],
        paytime: [],
        accountPhone: '',
        bookCode: '',
        deviceNo: '',
        startCreateDate: '',
        endCreateDate: '',
        startPayTime: '',
        endPayTime: '',
        status: 1,
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      propsData: {
        api: 'get_rentbook_pagelist'
      },
      searchFormRules: {
        time: [{ trigger: 'change', validator: validateDatePicker }],
        deviceNo: [{ validator: validateDeviceSn, trigger: 'blur' }],
        accountPhone: [{ validator: validateAccountPhone, trigger: 'blur' }],
        paytime: [{ trigger: 'change', validator: validateDatePicker }]
      }
    };
  },
  computed: {
    query() { // 获取跳转传参
      return this.$store.state.ella.queryElla;
    },
    columns() {
      return columnsRentBook;
    }
  },
  watch: {
    query: { // 跳转传参
      handler: function(val) {
        if (val) {
          this.searchForm.bookCode = (val && deepCopy(val.bookCode)) || '';
          this.searchForm.accountPhone = (val && deepCopy(val.accountPhone)) || '';
          this.$nextTick(() => {
            this.$refs.componentsList && this.$refs.componentsList.fetchdataList();
          });
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.commit('SET_LINKRENTBOOKQUERY', null); // 清空正常访问下传参
  },
  methods: {
    // 导出
    exportExcel() {
      if (this.searchForm.paytime) {
        this.getTime(this.searchForm.time, { start: 'startCreateDate', end: 'endCreateDate' });
      }
      if (this.searchForm.paytime) {
        this.getTime(this.searchForm.paytime, { start: 'startPayTime', end: 'endPayTime' });
      }
      var op = this.searchForm;
      delete op.total;
      window.location.href = EllaRentBooks.exportRentbookExcel(op) ? EllaRentBooks.exportRentbookExcel(op) : null;
    },
    // 日期处理
    getTime(time, timeProps) {
      if (time && time.length > 0) {
        this.searchForm[timeProps.start] = time[0];
        this.searchForm[timeProps.end] = time[1];
      } else {
        this.searchForm[timeProps.start] = '';
        this.searchForm[timeProps.end] = '';
      }
    },
    // 默认时间显示
    dafaultVulue() {
      this.searchForm.time = [getDateTime(0), getDateTime(0)];
      this.getTime(this.searchForm.time, { start: 'startCreateDate', end: 'endCreateDate' });
    },
    dafaultPayVulue() {
      this.searchForm.paytime = [getDateTime(0), getDateTime(0)];
      this.getTime(this.searchForm.paytime, { start: 'startPayTime', end: 'endPayTime' });
    },
    // 时间变化
    timeChange(val) {
      if (val && val.length > 0) {
        this.getTime(this.searchForm.time, { start: 'startCreateDate', end: 'endCreateDate' });
      } else {
        this.searchForm.startCreateDate = '';
        this.searchForm.endCreateDate = '';
      }
    },
    paytimeChange(val) {
      if (val && val.length > 0) {
        this.getTime(this.searchForm.paytime, { start: 'startPayTime', end: 'endPayTime' });
      } else {
        this.searchForm.startPayTime = '';
        this.searchForm.endPayTime = '';
      }
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.$refs.componentsList.fetchdataList();
        }
      });
    },
    // 重置
    handleSearchReset() {
      this.searchForm = {
        time: [],
        paytime: [],
        accountPhone: '',
        bookCode: '',
        deviceNo: '',
        startCreateDate: '',
        endCreateDate: '',
        startPayTime: '',
        endPayTime: '',
        status: 1,
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
      this.$nextTick(() => {
        this.$refs.componentsList.fetchdataList();
      });
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
